import React from "react";
import {
  Modal,
  ModalHeader,
  ModalProps,
} from "@sonder/ui/source/styled/components/Modal";
import { ModalFooter } from "@sonder/ui/source/styled/fragments/Modal";
import { PrimaryButton } from "@sonder/ui/source/styled/fragments/PrimaryButton";
import { useUpdateAllUserNotifications } from "core/queries/UpdateAllUserNotifications";

export const ArchiveAllNotificationsModal = ({
  isOpen,
  onClose,
}: Omit<ModalProps, "children">) => {
  const [onUpdateAllNotifications, { loading: isUpdating }] =
    useUpdateAllUserNotifications({
      awaitRefetchQueries: true,
      onCompleted: () => {
        if (onClose) onClose();
      },
      refetchQueries: ["GetNotifications", "GetNotificationsTotal"],
    });
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {({ closeModal }) => (
        <>
          <ModalHeader title="Archive All Notifications" onClose={closeModal} />
          <p>Are you sure you want to archive all Notifications?</p>
          <p>
            <b>Note: This cannot be undone!</b>
          </p>
          <ModalFooter>
            <PrimaryButton
              disabled={isUpdating}
              onClick={() => {
                onUpdateAllNotifications({ variables: { archive: true } });
              }}
            >
              I&apos;m sure
            </PrimaryButton>
          </ModalFooter>
        </>
      )}
    </Modal>
  );
};
